import { render } from "./DiagnosticoLOV.vue?vue&type=template&id=c26cc4e0"
import script from "./DiagnosticoLOV.vue?vue&type=script&lang=js"
export * from "./DiagnosticoLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__